export const capitalizeString = ([firstLetter, ...restOfWord]: string): string => {
  return `${firstLetter.toUpperCase()}${restOfWord.join('').toLowerCase()}`;
};
